import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRODUCT_IMAGE, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-ink px-5 py-24 text-paper sm:px-14 sm:py-32" data-id="element-165" data-mp="1mnsb8ey5ui9l">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-166" data-mp="1hnw7mgtdksuk">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-167" data-mp="tylcpfyphsoc">
          <h2 className="font-display text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-168" data-mp="tzd7iokhbmdk">
            Découvrez votre offre <em className="text-pen-soft" data-id="element-169" data-mp="p1v1b5xujl99">SCIENCES PRÊTES™</em>
          </h2>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-[0_30px_40px_rgba(0,0,0,0.35)] lg:block" data-id="element-170" data-mp="13ylyr9nymmw8" />
        </div>

        <div className="rounded-3xl bg-paper p-6 text-ink shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)] sm:p-11 lg:col-span-6" data-id="element-171" data-mp="2fad1td6taqc3">
          <p className="text-sm font-semibold text-ink/60" data-id="element-172" data-mp="2affy8lsax96l">Le pack SCIENCES PRÊTES™</p>

          <ul className="mt-5 divide-y divide-ink/10 border-y border-ink/10" data-id="element-173" data-mp="pmbh3vw3p661">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-174" data-mp="zieslscueh5n">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-pen" data-id="element-175" data-mp="zj6e2acq6yi7">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-176" data-mp="13hvyuo03fibv" />
                </span>
                <span data-id="element-177" data-mp="bsu0aiusu7jp">
                  <span className="block font-medium leading-snug" data-id="element-178" data-mp="bs1060qcigaj">{row.label}</span>
                  {row.detail && <span className="mt-0.5 block text-sm text-ink/65" data-id="element-179" data-mp="ftm9jc3o8cfz">{row.detail}</span>}
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex items-end justify-between gap-4" data-id="element-180" data-mp="3k9fc07etfeqi">
            <p className="pb-2 text-sm font-medium text-ink/70" data-id="element-181" data-mp="3oa7jow81hbko">Votre pack complet&nbsp;:</p>
            <p className="font-display text-7xl leading-none tracking-tight text-ink sm:text-8xl" data-id="element-182" data-mp="3o7uxg6v90f1t">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-end gap-2 text-sm text-ink/70" data-id="element-183" data-mp="qfurhyeo7daj">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="154ijjupb54vq" />
            Paiement unique. Aucun abonnement.
          </p>

          <CtaButton className="mt-8 w-full" data-id="element-185" data-mp="1078xmp14nbcn" />

          <p className="mt-5 text-center text-xs text-ink/60" data-id="element-186" data-mp="cgcy15qfjbuu">
            Fichiers PDF · Supports imprimables · Aucun produit physique expédié
          </p>
        </div>
      </div>
    </section>;
}